import XLSX from 'xlsx'

function formatEquipmentLogs (logs) {
	if(logs) {
		const notes = logs.filter((log) => log.action === 'addNote')
		let content = ''
		notes.forEach((note, i) => {
			content += note.created.slice(0, 9) + " "
			content += note.text + ';  '
		})
		return content
	}
	return ''
}

export default {

	exportRecords (records, exportFields, filename, filetype, callback) {
		//  headings
		let heading = []
		let fields = Object.keys(exportFields)
		for (let field of fields) {
			heading.push(exportFields[field])
		}
		//  data
		let data = [heading]
		let counter = 1
		if (records) {
			for (let record of records) {
				// let row = [counter.toString()]
				let row = []
				for (let field of fields) {
					//  retrieve value
					let value = record[field]
					if (callback) {
						value = callback(field, value, record)
					}
					//  strings only
					if ((value === undefined) || (value === null)) {
						value = ''
					}
					//  output
					row.push(value)
				}
				data.push(row)
				counter++
			}
		}

		//  worksheet & workbook
		let ws = XLSX.utils.aoa_to_sheet(data)
		let wb = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, 'sheet')
		//  download
		XLSX.writeFile(wb, filename + '.' + filetype)
	},

	exportRows (rows, filename, filetype) {
		//  worksheet & workbook
		let ws = XLSX.utils.aoa_to_sheet(rows)
		let wb = XLSX.utils.book_new()
		XLSX.utils.book_append_sheet(wb, ws, 'sheet')
		//  download
		XLSX.writeFile(wb, filename + '.' + filetype)
	},

	equipmentCallback (field, value, record) {
		//Parsing compliance_2022, compliance_2023 etc...
		if (field.indexOf('compliance') > -1) {
			let year = field.split('_')[1]
			let compliance = record.compliances.find((c) => {
				return c.effective === year
			})
			return compliance?.status
		}
		if (field === 'company') {
			return value.name
		}
		if (field === 'on_road') {
			return !!value
		}
		if (field === 'cobid_certified') {
			return !!record.company.cobid_certified
		}
		if (field === 'exemption_type') {
			let exemption = record.exemptions[0]
			return exemption?.type
		}
		if (field === 'exemption_granted_thru') {
			let exemption = record.exemptions[0]
			return exemption?.granted_thru
		}
		if (field === 'userLogs') {
			return formatEquipmentLogs(record.userLogs)
		}
		return value
	}
}
